import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G fill="#000">
        <Path d="M12.572 8l-5.937 5.948c-.22.22-.357.507-.393.815l-.236 2.08A1.048 1.048 0 007.05 18h.121l2.078-.237c.306-.036.592-.172.813-.387L16 11.422 12.572 8zM18.618 6.824l-1.442-1.442a1.298 1.298 0 00-1.84 0L14 6.719 17.281 10l1.337-1.337a1.299 1.299 0 000-1.84z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
